import React from 'react'
import { ajax, Status, getState } from '../../twd'

const state = getState('municipals.muni-tickers', {
    tickerData: []
})

export default () => {

    const [tickerData, setTickerData_] = React.useState(state.value.tickerData || [])
    const setTickerData = React.useCallback((m) => {
        state.set({tickerData:m})
        setTickerData_(m)
    }, [])

    const [status, setStatus] = React.useState(Status.LOADING)
    const lastAbort = React.useRef()

    React.useEffect(() => {

        setTickerData([])
        ;(async () => {
            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                setStatus(Status.LOADING)
                let {data, abort} = await ajax({
                    url: '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType',
                    method: 'POST',
                    params: {
                        marketSnapshotsType: 'MUNI_TICKER_DATA'
                    }
                })

                lastAbort.current = abort
                let rs = await data
                setTickerData(rs)
                lastAbort.current = null

                setStatus(Status.LOADED)
            } catch(e) {
                setTickerData([])
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

        return () => {
            if (lastAbort.current) lastAbort.current()
        }

    }, [setTickerData])

    return {
        status,
        tickerData
    }
}